import React from "react";
import Translation from "../classes/Translation";
import CreatorModal from "./CreatorModal";

export class MatVariatSelect extends React.Component {  
    constructor(props){
        super(props);
        this.state = {
            project: this.props.project,
            _default: this.props.project.mat_variat ? this.props.project.mat_variat_default_product : 0,
            sizeTableClicked: 0,
            sizeTableVisible: 0,
        };
      };  

    handleChange = e => {
        this.setState({_default: e.target.value}, () => {
            this.changePrice();
        });
    }

    changePrice = () => {
        if(this.state.project.mat_variat)
        {
            let add_to_price = 0;
            this.state.project.mat_variat_products.map((val) => {
                if(this.state._default === val.id_product && val.quantity > 0)
                {
                    add_to_price = val.add_to_price;
                }
                else if (this.state._default === 0 && val.add_to_price === 0 && val.quantity > 0)
                {
                    add_to_price = val.add_to_price;
                }

            });
            const element = document.querySelector('.add-to-cart strong span');
            if(element)
            {
                const valueAttr = element.getAttribute('content').split(' '+window.prestashop.currency.sign)[0];
                let newPrice = Number(Number(valueAttr)+Number(add_to_price)).toFixed(2).replace('.00', '');
                element.textContent = newPrice + " " + window.prestashop.currency.sign; 
            }
        }
    }
    
    componentDidMount(){
        this.changePrice();
    }

    onClickSizeTable = (e) => {
        this.setState({
            sizeTable: 1,
            sizeTableVisible: 1
        })
    }
    closeModal = (e, tabindex = undefined) => {       
        this.setState({
            sizeTableVisible: 0,
            sizeTableClicked: 0
        });
    }
    render() {   
        const {sizeTable, sizeTableVisible, project, _default} = this.state;
        return (
                <div>
                    {
                        (()=>{
                            if(project.mat_variat)
                            {
                                return <div>
                                    {
                                        (()=>{
                                            if(project.mat_variat && project.id_mat_variat>0 && project.mat_variat.label && project.mat_variat.show_label == 1)
                                            {
                                                return <div className="select_label">{project.mat_variat.label}</div>
                                            }                                      
                                        })()                        
                                    }
                                    <select 
                                        id="mat_variat_select"  
                                        className="select_mat_variat form-control"
                                        name={"creator["+project.id_tab+"][id_mat_variat_product]"}
                                        onChange={this.handleChange} 
                                    >
                                        {project.mat_variat_products.map((val) => {
                                            let selected = ""
                                            let disabled = ""
                                            let disabled_info = ""
                                            if(_default === val.id_product && val.quantity > 0)
                                            {
                                                selected = "selected"
                                            }
                                            else if (_default === 0 && val.add_to_price === 0 && val.quantity > 0)
                                            {
                                                selected = "selected"
                                            }
                                            if(val.quantity <= 0)
                                            {
                                                disabled = "disabled";
                                                disabled_info = " "+Translation.getTranslation('outofstock');   
                                            }
                                            let op = <option 
                                                value={val.id_product} 
                                                data-add_to_price={val.add_to_price} 
                                                selected={selected} 
                                                disabled={disabled}>
                                                    {val.name_mat_variat_product} {disabled_info}
                                                </option>
                                            return op
                                        })}
                                    </select>
                                    {
                                        (()=>{
                                            if(project.mat_variat && project.mat_variat.html_content && window.prestashop.language.iso_code=="pl")
                                            {
                                                return <div style={{float: "right", textAlign: "center", width: "9rem", cursor: "pointer"}}>
                                                            <div
                                                                className="size_table_header"
                                                                onClick={this.onClickSizeTable}
                                                            >
                                                                {Translation.getTranslation(`sizeTable`)}
                                                            </div>
                                                            { 
                                                                sizeTable && 
                                                                <CreatorModal
                                                                    closeModal={this.closeModal}
                                                                    title={Translation.getTranslation('sizeTable')}
                                                                    visibility={sizeTableVisible}
                                                                    content={project.mat_variat.html_content}
                                                                />
                                                            }                                                            
                                                        </div>
                                            }
                                        })()
                                    }
                                </div>
                            }
                        })()
                    }
                </div>
            )
      }
}

export class VariantsSelect extends React.Component { 
    constructor(props){
        super(props);
        this.state = {
            data: this.props.project,
        };
      }; 

    isDefaultItemOutOfStock = (variants) => {
        for(var item of variants){
            if(item.id_product == this.state.data.product_layer_id_product && item.quantity > 0){
                return false;
            }
        }
        return true;
    }
      render() {
        const {data} = this.state;
        return (
            <div class="inputs">
                {
                    (()=>{
                        if(data.variants && data.variants.options.length > 1)
                        {
                            var _isDefaultItemOutOfStock = this.isDefaultItemOutOfStock(data.variants.options);
                            var itemAlreadySelected = false;
                            return <>
                                {
                                    (()=>{
                                        if(data.variants.settings.show_label == 1 && data.variants.settings.label != "")
                                        {
                                            return <div className="select_label">{data.variants.settings.label}</div>
                                        }                                      
                                    })()                        
                                }
                                
                                <select 
                                        id="variant_select"  
                                        className="creator_input form-control"
                                        onChange={this.props.onChange} 
                                    >
                                        {data.variants.options.map((val) => {
                                            var select = false;
                                            var disable = false;
                                            var disabled_info = "";
                                            if(_isDefaultItemOutOfStock && !itemAlreadySelected){
                                                if(val.quantity > 0){
                                                    itemAlreadySelected = true;
                                                    select = true; 
                                                    data['product_layer_image']=this.props.image_source(val.id_image);
                                                    data['product_layer_texture']=this.props.image_source(val.id_texture); 
                                                    var obj =document.querySelector('#custom_form_'+data.id_tab+' #id_variant');
                                                    if(obj !== null)
                                                    {
                                                        obj.value=val.id_product;
                                                    }
                                                }
                                            }else if(!itemAlreadySelected){
                                                if(val.id_product == data['product_layer_id_product']){
                                                    itemAlreadySelected = true;
                                                    select = true;
                                                    data['product_layer_image']=this.props.image_source(val.id_image);
                                                    data['product_layer_texture']=this.props.image_source(val.id_texture); 
                                                    var obj =document.querySelector('#custom_form_'+data.id_tab+' #id_variant');
                                                    if(obj !== null)
                                                    {
                                                        obj.value=val.id_product;
                                                    }
                                                }
                                            }
                                            if(val.quantity <= 0)
                                            {
                                                 disable = "disabled";
                                                 disabled_info = " "+Translation.getTranslation('outofstock');   
                                            }
                                            let op = <option 
                                                value={val.id_product} 
                                                data-id_image={val.id_image}
                                                data-id_texture={val.id_texture}
                                                data-id_stage={data.id_tab}
                                                selected={select} 
                                                disabled={disable} 
                                                >
                                                    {val.name_mat_variat_product}{disabled_info}
                                                </option>
                                            return op
                                        })}
                                    </select>
                            </>
                        }
                    })()
                }
            </div>
        )
      }
}
